import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import PageShell from "./shared/PageShell";
import { pageStyles } from "./shared/theme";

const Section = ({ title, content }) => (
  <Box mb={5}>
    <Typography
      variant="h5"
      sx={{
        fontFamily: "inherit",
        fontWeight: 600,
        mb: 1.5,
        textAlign: "left",
        color: "#1E293B",
      }}
    >
      {title}
    </Typography>
    <Typography
      variant="body1"
      sx={{
        fontFamily: "inherit",
        textAlign: "left",
        lineHeight: 1.7,
        color: "#334155",
      }}
    >
      {content}
    </Typography>
  </Box>
);

const MigrationInfo = () => {
  return (
    <PageShell wide topAligned>
        <Typography
          component="h1"
          variant="h1"
          sx={{ ...pageStyles.title, mb: 4 }}
        >
          Migration FAQs
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Section
          title="What is this migration for?"
          content="Finn is transitioning its brokerage partner from Atomic Invest, LLC to Alpaca Securities LLC. This change allows us to better serve you with faster transfers, better reliability, and access to more investment options in the future."
        />

        <Section
          title="How long will this migration take?"
          content="Your accounts are already live on Alpaca. That means you're ready to trade again through the Finn App—no additional steps needed."
        />

        <Section
          title="Why are my balances being reflected incorrectly?"
          content="We are using the ACATs system to transfer your holdings between institutions. While most assets move quickly, funds from recent maturity events may not transfer immediately. These will usually appear in your account within 7–10 days after the maturity date."
        />
    </PageShell>
  );
};

export default MigrationInfo;
